import React, { ReactNode } from 'react';
import './WprWaitComponent.css';

/**
 * 待機表示コンポーネントプロパティ情報
 */
interface IWprWaitProps {
	visibility?: boolean;		// 表示状態
}

/**
 * 待機表示コンポーネント
 */
export class WprWaitComponent extends React.Component<IWprWaitProps> {
	// プロパティ  ---------------------------------------------------------------
	/** 編集フラグ */
	public get isEdit(): boolean	{ return false; 	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 描画
	 */
	public render(): ReactNode {
		if (!this.props.visibility)
			return <></>;
		return (
			<>
				<div className="popup" id="js-popup">
					<div className="popup-inner">
						<div className="wrapper">
							<div className="balls-guruguru">
								<span className="ball ball-1"></span>
								<span className="ball ball-2"></span>
								<span className="ball ball-3"></span>
								<span className="ball ball-4"></span>
								<span className="ball ball-5"></span>
								<span className="ball ball-6"></span>
								<span className="ball ball-7"></span>
								<span className="ball ball-8"></span>
							</div>
						</div>	
					</div>
					<div className="black-background" id="js-black-bg"></div>
				</div>
			</>
		);
	}
	// --------------------------------------------------------------------------
}